import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { DashboardWidgetEntity } from './dashboard-widget.entity';
import { UserEntity } from './user.entity';

@Index('idx_active', ['isActive'], {})
@Index('idx_filter_key', ['filterKey'], {})
@Index('idx_overrides', ['overridesDashboard'], {})
@Index('idx_widget', ['fkDashboardWidgetId'], {})
@Index('fk_user__id', ['fkUserId'], {})
@Entity('widget_filter')
export class WidgetFilterEntity extends BaseEntity {
	@Column('int', { name: '_fk__dashboard_widget__id', unsigned: true })
	public fkDashboardWidgetId!: number;

	// Scope of this filter row.
	//   NULL  = shared (saved on the dashboard; visible to every viewer)
	//   not NULL = personal to that tenant user._id (only that user sees it)
	@Column('int', { name: 'fk_user__id', unsigned: true, nullable: true })
	public fkUserId!: number | null;

	@Column('varchar', { name: 'filterKey', length: 100 })
	public filterKey!: string;

	@Column('varchar', { name: 'filterType', length: 50 })
	public filterType!: string;

	@Column('json', { name: 'filterValue', nullable: true })
	public filterValue!: object | null;

	@Column({
		type: 'boolean',
		name: 'overridesDashboard',
		nullable: true,
		width: 1,
		default: () => "'1'",
	})
	public overridesDashboard!: boolean | null;

	@Column({
		type: 'boolean',
		name: 'isActive',
		nullable: true,
		width: 1,
		default: () => "'1'",
	})
	public isActive!: boolean | null;

	@Column('int', {
		name: 'sortOrder',
		nullable: true,
		unsigned: true,
		default: () => "'0'",
	})
	public sortOrder!: number | null;

	@ManyToOne(
		() => DashboardWidgetEntity,
		(dashboardWidget) => dashboardWidget.widgetFilters,
		{ onDelete: 'CASCADE', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__dashboard_widget__id', referencedColumnName: 'id' },
	])
	public fkDashboardWidget!: DashboardWidgetEntity;

	@ManyToOne(() => UserEntity, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
		nullable: true,
	})
	@JoinColumn([{ name: 'fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity | null;
}
